import { render, staticRenderFns } from "./errorCard.vue?vue&type=template&id=5fbb4c4a&scoped=true&"
import script from "./errorCard.vue?vue&type=script&lang=js&"
export * from "./errorCard.vue?vue&type=script&lang=js&"
import style0 from "./errorCard.vue?vue&type=style&index=0&id=5fbb4c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbb4c4a",
  null
  
)

export default component.exports